import React, { createContext, useEffect, useState } from 'react'
import axios from 'axios';
import $ from 'jquery';
import { useContext } from 'react';
import { enqueueSnackbar } from 'notistack';
import { constantsErrorMessage, removeSuccessMessage, changeError, changeSuccess } from '../../constants/global';
import { useTranslation } from 'react-i18next';
import jwt_decode from "jwt-decode";
import { Navigate, useNavigate } from 'react-router-dom';

export const apiContext = createContext(0);

export default function ApiProvider(props) {

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  // decoded token
  function decodeToken() {
    let token = localStorage.getItem("token")
    if (token) {
      const decoded = jwt_decode(token);
      if (decoded.exp < Date.now() / 1000 || !decoded.exp) {
        localStorage.clear();
        navigate("/login");
      }
      return decoded;
    }
  }

  function getSlug() {
    const decoded = decodeToken();
    return decoded.slug;
  }

  // get data
  async function getData(setRowData, endPoint) {
    const res = await axios({
      url: `${props.baseUrl}${endPoint}`,
      method: "get",
      headers: {
        'Content-Type': 'application/json',
        "authorization": `Bearer ${props.token}`,
      }
    })
    if (res.data) {
      if (setRowData) {
        setRowData(res.data.results)
      }
      return res.data;
    }
  }

  // add data and edit data
  async function responseApi(method, data = {}, endPoint, id) {
    const res = await axios({
      url: method === "put" ? `${props.baseUrl}${endPoint}/${id}` : `${props.baseUrl}${endPoint}`,
      method,
      data,
      headers: {
        'Content-Type': 'application/json',
        "authorization": `Bearer ${props.token}`,
      }
    })
    if (res.data) {
      return res.data;
    }
  }

  // remove data
  async function removeUserApi(id, endPoint, setRowData) {
    const { data } = await axios({
      method: "patch",
      url: `${props.baseUrl}${endPoint}/${id}`,
      headers: {
        'Content-Type': 'application/json',
        "authorization": `Bearer ${props.token}`,
      },
    })
    ////(data);
    props.togglePopUp('add-confirm');
    if (data.message === "success") {
      enqueueSnackbar(<>{t(removeSuccessMessage)}</>, { variant: "success" });
    } else {
      enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(data.message)}</>, { variant: "error" });
    }
    getData(setRowData, endPoint)
  }

  function confirmRemove(id, setId) {
    props.togglePopUp('add-confirm');
    setId(id)
  }

  //  show invalid message for validation input
  function showInvalidFeedback(array) {
    ////(array);
    $(`.text-helper-invalid`).addClass('d-none');
    array?.forEach(ele => {
      $(`#${ele.context.key}`).parent().parent().parent().next().removeClass('d-none');
    });

  }

  // quick edit in table
  async function quickEditTable(endPoint, dataUser, id, setRowData) {
    const { data } = await axios({
      url: `${props.baseUrl}${endPoint}/quickEdit/${id}`,
      method: "patch",
      data: dataUser,
      headers: {
        'Content-Type': 'application/json',
        "authorization": `Bearer ${props.token}`,
      }
    })
    console.log(dataUser);

    if (dataUser.reqStatus !== "confirmed") {
      props.togglePopUp('add-confirm');
    }
    if (data.message === "success") {
      enqueueSnackbar(<>{t(changeSuccess)}</>, { variant: "success" });
      getData(setRowData, endPoint);
    } else {
      return data
    }
  }

  async function quickEditDiscountStatus(endPoint, dataUser, id, setRowData) {
    const { data } = await axios({
      url: `${props.baseUrl}${endPoint}/quickEditDiscountStatus/${id}`,
      method: "patch",
      data: dataUser,
      headers: {
        'Content-Type': 'application/json',
        "authorization": `Bearer ${props.token}`,
      }
    })
    console.log(data);
    if (data.message === "success") {
      enqueueSnackbar(<>{t(changeSuccess)}</>, { variant: "success" });
      getData(setRowData, endPoint);
    } else {
      return data
    }
  }

  function ProtectedComponentRoles(props) { // shield for all routes
    const decodedToken = decodeToken();
    const userAuthorization = { role: decodedToken?.role || [] };
    if (decodedToken) {
      for (let i = 0; i < userAuthorization.role.length; i++) {
        if (props.roles.filter((ele) => ele === userAuthorization.role[i])?.length) {
          return props.children;
        }
      }
      return null;
    } else {
      return <Navigate to='/login' />
    }
  }

  // Function to check if user has required roles
  function checkUserRoles(requiredRoles) {
    const decodedToken = decodeToken();
    if (!decodedToken) {
      navigate("/login");
      return false;
    }
    
    const userRoles = decodedToken?.role || [];
    
    // Check if user has at least one of the required roles
    for (let i = 0; i < userRoles.length; i++) {
      if (requiredRoles.includes(userRoles[i])) {
        return true;
      }
    }
    return false;
  }

  // Protected function wrapper - executes function only if user has required roles
  function protectedFunction(requiredRoles, callback) {
    if (checkUserRoles(requiredRoles)) {
      return callback();
    } else {
      console.warn("User does not have required roles to execute this function");
      return null;
    }
  }


  // Load booking policies from backend
  const loadBookingPolicies = async () => {
    try {
      const bookingPolicies = sessionStorage.getItem("bookingPolicies");
      if (!bookingPolicies) {
        const response = await getData(null, 'bookingPolicies');
        if (response && response.results) {
          sessionStorage.setItem("bookingPolicies", JSON.stringify(response.results.bookingPolicies));
        }
      }
    } catch (error) {
      console.error('Error loading booking policies:', error);
      enqueueSnackbar(t('error.loadingFailed') || 'Failed to load policies', { variant: 'error' });
    }
  };
  useEffect(() => {
    loadBookingPolicies();
  }, [])




  return <apiContext.Provider value={{ getData, responseApi, removeUserApi, showInvalidFeedback, confirmRemove, quickEditTable, getSlug, quickEditDiscountStatus, ProtectedComponentRoles, checkUserRoles, protectedFunction }}>
    {props.children}
  </apiContext.Provider>
}


export const useApi = () => {
  const context = useContext(apiContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserContextProvider.");
  }
  return context;
};